import {useCallback} from "react";
import {useAuthenticatedApi} from "@webng/react-app-common";
import {PublicChannelSettings} from "./Models";
import {QueryFunction, useQuery} from "@tanstack/react-query";
import {ApiClient} from '@webng/tickaroo-api'

interface CommentSettingsApiProps {
  ownerId: string
  channelId: string
  version: number
}



type ChannelSettingsQueryKey = ["channelSettings", string, string, number]

export default function useChannelSettings({ownerId, channelId, version}: CommentSettingsApiProps){
  const apiClient = useAuthenticatedApi();

  const queryFn: QueryFunction<PublicChannelSettings, ChannelSettingsQueryKey> = useCallback(async ({queryKey}) => {
    const [, ownerId, channelId, version] = queryKey;
    return apiClient.get<PublicChannelSettings>(ApiClient.API_COMMENTS_V1_PUBLIC_CHANNEL_SETTINGS, {
      ownerId: ownerId,
      channelId: channelId,
      version: version
    })
  }, [apiClient]);

  const {data, isError, isLoading, error} = useQuery<PublicChannelSettings, Object, PublicChannelSettings, ChannelSettingsQueryKey>({
    queryKey: ['channelSettings', ownerId, channelId, version],
    queryFn,
    retry: true,
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity
  })

  return {
    data,
    isError,
    isLoading,
    error
  }
}
